const LIFESTYLE_IMG = "/hero/elder-couple-vitality.png";

export default function Testimonials({ t }) {
  return (
    <section
      data-testid="social-proof-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <p className="text-overline">{t.social.overline}</p>
          <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl md:text-5xl mt-5 text-[#1a2421] max-w-md">
            {t.social.title}
          </h2>

          <blockquote className="mt-10 border-l-2 border-[#bc6c25] pl-6 max-w-lg">
            <p className="font-serif text-2xl md:text-3xl italic leading-relaxed text-[#1a2421]">
              “{t.social.quote}”
            </p>
            <footer className="mt-5 text-sm uppercase tracking-[0.18em] text-[#5c6b61]">
              {t.social.author}
            </footer>
          </blockquote>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative">
            <img
              src={LIFESTYLE_IMG}
              alt="Vibrant longevity"
              className="w-full h-[420px] md:h-[560px] object-cover rounded-3xl"
              loading="lazy"
            />
            <div className="absolute -bottom-5 -left-5 bg-[#f9f6f0] rounded-2xl px-5 py-4 shadow-lg border border-[#2c4a3b]/10">
              <p className="font-serif text-3xl text-[#2c4a3b]">98%</p>
              <p className="text-xs uppercase tracking-[0.18em] text-[#5c6b61] mt-1">
                renewal rate
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
